import React, { useEffect } from 'react';
import api from '../../../libs/api';
import { useIntl } from 'components/i18n';
import { jsx } from '@emotion/react';
import { useNotifications } from '../../../components/notification';

const KlarnaAppLauncher: React.FC = (props) => {

  const {showSuccessNotification} = useNotifications();
  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'klarna-app-launcher';
    script.type = 'text/javascript';
    script.src = 'https://x.klarnacdn.net/xs2a/app-launcher/v0/xs2a-app-launcher.js';
    document.body.appendChild(script);
    // @ts-ignore
    window.onXS2AReady = XS2A => {
      console.log('onXS2A ready');
      // configure once for all flows (optional)
      XS2A.configure({
          autoClose: true,
          hideTransitionOnFlowEnd: true,
          onLoad: () => {
            console.log('onLoad called')
          },
          onReady: () => {
            console.log('onReady called')
          }
        }
      );
    };
      return () => {
        document.body.removeChild(script)
      }
  }, []);

  return <div></div>;
};

export default KlarnaAppLauncher;


export const startKlarnaFlow = async (bankCode?: string, language?: 'nl' | 'en') => {
  console.log('start klarna flow');
      const { sessionId, flowId, clientToken } = await api.put('/klarna-connections/sessions', {
        bankCode,
        language,
      });
      const closeSession = () => api.delete(`/klarna-connections/sessions/${sessionId}`);
      const createKlarnaConnection = () => api.post('/klarna-connections/setup', {
        sessionId,
        flowId,
      });
      console.log('window.XS2A.startFlow', clientToken);
      return new Promise(async (resolve, reject) => {

        (window as any).XS2A.startFlow(clientToken,
          {
            onAbort: () => {
              console.log('onAbort called');
              closeSession();
              reject();
            },
            onError: (error: any) => {
              console.log('onError called', error);
              closeSession();
              reject(error);
            },
            onFinished: async () => {
              console.log('onFinished called');
              const klarnaConnection = await createKlarnaConnection();
              resolve(klarnaConnection);
            },
            onClose: () => {
              console.log('onClose called');
            },
          }
        )
      });
};
